import _defineProperty from "/Users/laurogripa/code/kusama/kappasigmamu.github.io/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
export class TextDecoder {
  constructor(encoding) {
    _defineProperty(this, "__encoding", void 0);
    this.__encoding = encoding;
  }
  decode(value) {
    let result = '';
    for (let i = 0, count = value.length; i < count; i++) {
      result += String.fromCharCode(value[i]);
    }
    return result;
  }
}